import React from "react"

export const FeatureWrapper = ({ children }) => {
  return (
    <section className="mb-16 mx-auto px-6 max-w-7xl md:mb-24">
      <div className="grid lg:gap-x-8 lg:grid-cols-2">{children}</div>
    </section>
  )
}
